import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {IonicModule} from '@ionic/angular';
import {CodeSelectPageRoutingModule} from './code-select-routing.module';
import {CodeSelectPage} from './code-select.page';
import {SharedModule} from 'src/app/shared/shared.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        CodeSelectPageRoutingModule,
        SharedModule
    ],
    declarations: [CodeSelectPage]
})
export class CodeSelectPageModule { }
